import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import {
  Drawer,
  Button,
  Radio,
  Space,
  Row,
  Col,
  Form,
  Input,
  Select,
  DatePicker,
  Divider,
  Card,
} from "antd";
import _ from "lodash";
import { LanguageContext } from "../../context/LanguageContext";
const { forwardRef, useRef, useImperativeHandle } = React;
export const ProfileForm = forwardRef((props, ref) => {
  const [form] = Form.useForm();
  const [user, SetUser] = useState({});
  const [basicDistricts, SetBasicDistricts] = useState([]);
  const [pc_cities, SetPC_cities] = useState([]);
  const [isSave, setIsSave] = useState(null);
  const [isUpdate, setIsUpdate] = useState(false);
  const [currentValueRadio, setcurrentValueRadio] = React.useState(2);
  const { language, setLanguage, t } = useContext(LanguageContext);
  useEffect(() => {
    SetUser(props.user);
  }, [props.user]);

  useEffect(() => {
    if (props.resetFrom && props.resetFrom) {
      form.resetFields();
    }
  }, [props.resetFrom]);

  useImperativeHandle(ref, () => ({
    onFinish(flag) {
      setIsSave(flag);
      form.submit();
    },
  }));

  useEffect(() => {
    const { users } = props.users;
    if (props.districtData && props.districtData.length) {
      let temp = props.districtData.map((item) => {
        return {
          ...item,
          isUsed: !!_.filter(users, (o) => {
            return o.districtId === item.id;
          }).length,
        };
      });
      SetBasicDistricts(temp);
    }
    if (props.cityData && props.cityData.length) {
      let temp = props.cityData.map((item) => {
        return {
          ...item,
          isUsed: !!_.filter(users, (o) => {
            return o.cityId === item.id;
          }).length,
        };
      });
      SetPC_cities(temp);
    }
  }, [props.cityData, props.districtData, props.users]);

  useEffect(() => {
    if (props.userFormEditData) {
      setIsUpdate(true);
      let val = props.userFormEditData;
      delete val.password;
      form.setFieldsValue({
        ...val,
      });
    }
  }, [props.userFormEditData]);

  useEffect(() => {
    if (props.isUpdate) {
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  }, [props.isUpdate]);

  const onFinish = (values) => {
    props.onFormUpdate(values);
  };

  return (
    <Card style={{ width: "100%" }}>
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Divider orientation="left">Basic Information</Divider>

        <Row gutter={24}>
          <Col span={8}>
            <Form.Item
              name="name"
              label={t("name")}
              rules={[
                {
                  required: true,
                  message: "कृपया वापरकर्त्याचे नाव प्रविष्ट करा",
                },
              ]}
            >
              <Input placeholder="कृपया वापरकर्त्याचे नाव प्रविष्ट करा" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="userid"
              label={t("user_id")}
              rules={[{ required: true, message: "Please Enter the User Id" }]}
            >
              <Input placeholder="Please Enter the User Id" disabled />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="phone"
              label={t("mobile_number")}
              rules={[
                { required: true, message: "Please Enter the Mobile Number" },
              ]}
            >
              <Input
                placeholder="Please Enter the Mobile Number"
                disabled={true}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              className="rememberMeCheckbox"
              name="remember"
              valuePropName="checked"
            >
              {t("password_change")}
              <Radio.Group
                onChange={(e) => {
                  console.log("radio checked", e.target.value);
                  setcurrentValueRadio(e.target.value);
                }}
                value={currentValueRadio}
                style={{ marginLeft: "10px" }}
              >
                <Radio value={1}>{t("yes")}</Radio>

                <Radio value={2}>{t("no")}</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        {currentValueRadio && currentValueRadio == 1 && (
          <Divider orientation="left">{t("change_password")}</Divider>
        )}
        {currentValueRadio && currentValueRadio == 1 && (
          <div style={{ width: "50%" }}>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="password"
                  label={t("new_password")}
                  rules={[
                    {
                      required: true,
                      message: "Please input your password!!",
                    },
                    () => ({
                      validator(_, value) {
                        if (!value) {
                          return Promise.reject();
                        }
                        if (value.length < 8) {
                          return Promise.reject(
                            "Password can't be less than 8",
                          );
                        }
                        if (value.length > 15) {
                          return Promise.reject(
                            "Password can't be more than 15",
                          );
                        }
                        if (value.search(/[a-z]/i) < 0) {
                          return Promise.reject(
                            "Password must contain at least one one lowercase letter.",
                          );
                        }
                        if (value.search(/[A-Z]/) < 0) {
                          return Promise.reject(
                            "Password must contain at least one uppercase letter.",
                          );
                        }
                        if (value.search(/[0-9]/) < 0) {
                          return Promise.reject(
                            "Password must contain at least one digit.",
                          );
                        }
                        if (value.search(/[!#$%&?]/) < 0) {
                          return Promise.reject(
                            "Password must contain at least one Special characters.",
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                  hasFeedback
                >
                  <Input.Password />
                </Form.Item>

                <Form.Item
                  name="confirm"
                  label={t("confirm_password")}
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password!",
                    },
                    () => ({
                      validator(_, value) {
                        if (!value) {
                          return Promise.reject();
                        }
                        if (value.length < 8) {
                          return Promise.reject(
                            "Password can't be less than 8",
                          );
                        }
                        if (value.length > 15) {
                          return Promise.reject(
                            "Password can't be more than 15",
                          );
                        }
                        if (value.search(/[a-z]/i) < 0) {
                          return Promise.reject(
                            "Password must contain at least one one lowercase letter.",
                          );
                        }
                        if (value.search(/[A-Z]/) < 0) {
                          return Promise.reject(
                            "Password must contain at least one uppercase letter.",
                          );
                        }
                        if (value.search(/[0-9]/) < 0) {
                          return Promise.reject(
                            "Password must contain at least one digit.",
                          );
                        }
                        if (value.search(/[!#$%&?]/) < 0) {
                          return Promise.reject(
                            "Password must contain at least one Special characters.",
                          );
                        }
                        return Promise.resolve();
                      },
                    }),
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The two passwords that you entered do not match!",
                          ),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </Col>
            </Row>
          </div>
        )}
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item>
              <Button type="primary" htmlType="submit">
                {t("update")}
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Card>
  );
});
